export const NOTIFICATIONS_TITLE = "Envío de noticias";
export const NOTIFICATIONS_CELLPHONE_TITLE = "Titulo de la notificación";
export const NOTIFICATIONS_CELLPHONE_BODY = "Cuerpo de la notificación";
export const NOTIFICATIONS_CELLPHONE_LINK = "Ver más: ";
export const NOTIFICATIONS_PREVIEW_TITLE = "Vista previa del dispositivo";
export const NOTIFICATIONS_PREVIEW_MESSAGE =
  "En esta vista previa, se ofrece una idea general de cómo se mostrará tu mensaje en un dispositivo móvil. La apariencia real del mensaje varía en función del dispositivo. Para obtener resultados precisos, prueba con un dispositivo real.";
export const NOTIFICATION_PREVIEW_VIEW_TAG_INITIAL = "Vista inicial";
export const NOTIFICATION_PREVIEW_VIEW_TAG_EXPANDED = "Vista expandida";
export const NOTIFICATIONS_BUTTON_SUBMIT = "Enviar";
export const NOTIFICATIONS_BUTTON_RESET = "Limpiar";
export const NOTIFICATIONS_BUTTON_ADD_IMAGE = "Añadir imagen";

// ------------------- ABM CATEGORIES ---------------------//
export const ABM_CATEGORIES_TITLE_CATEGORIES = "CATEGORIAS";
export const ABM_CATEGORIES_TITLE_SUBCATEGORIES = "SUBCATEGORIAS";
export const ABM_CATEGORIES_TITLE_BUTTON_CATEGORIES = "AGREGAR CATEGORIA";
export const ABM_CATEGORIES_TITLE_BUTTON_SUBCATEGORIES = "AGREGAR SUBCATEGORIA";
export const ABM_CATEGORIES_TITLE_DIALOG_CATEGORY = "Agregar nueva categoria";
export const ABM_CATEGORIES_TITLE_DIALOG_SUBCATEGORY =
  "Agregar nueva subcategoria";
export const ABM_CATEGORIES_DIALOG_MESSAGE = "Ingrese el nombre.";
export const ABM_CATEGORIES_BUTTON_CANCEL = "Cancelar";
export const ABM_CATEGORIES_BUTTON_ADD = "Agregar";
export const ABM_CATEGORIES_LIST_HEADER_NAME = "Nombre";
export const ABM_CATEGORIES_LIST_HEADER_ACTIVATED = "Activada";

// ---------------------- USERS ---------------------------//

export const USERS_ROLES_ADMIN_TITLE = "ADMINISTRADOR DE ROLES";
export const USERS_ROLES_ADMIN_MAIN_ROLE = "Rol principal";
export const USERS_ROLES_ADMIN_SAVE_BUTTON = "GUARDAR";
export const USERS_ROLES_ADMIN_CANCEL_BUTTON = "CANCELAR";
export const USERS_ROLES_ADMIN_LEFT_LIST = "Roles Adicionales";
export const USERS_ROLES_ADMIN_RIGHT_LIST = "Roles actuales";

// ------------------------ FARMACIAS DE TURNO ------------------------------//

export const PHARMACY_TITLE = "Administador de Farmacias de Turno";
export const PHARMACY_MESSAGE =
  "Arrastre y suelte la farmacia sobre el día indicado en el calendario.";

// --------------------------- REPORTES -------------------------------------//
export const REPORT_NAME_STATE = [
  "Pendiente de confirmación",
  "Recepcionado",
  "En progreso",
  "Finalizado",
  "Desestimado",
];
export const REPORT_EXPANDED_BUTTON = [
  "Recepcionar",
  "En progreso",
  "Finalizar",
];
export const REPORT_DISMISS_BUTTON = "Desestimar";

// --------------------------- RESERVAS -------------------------------------//

export const RESERVATION_TITLE = "Sistema de reservas";
export const RESERVATION_SEARCH_BUTTON = "Buscar";
export const RESERVATION_SEARCH_MESSAGE =
  "Utilice los criterios de busqueda para obtener los asistentes de un evento en un determinado turno.";
export const RESERVATION_EXPORT_MESSAGE =
  "Puede exportar los datos para imprimirlos utilizando el botón XLSX.";

// --------------------------- ABM EVENTOS ----------------------------------//

export const ABM_EVENTS_TITLE = "Administrador de eventos";
export const ABM_EVENTS_EVENT_CREATE_BUTTON = "Crear evento";
export const ABM_EVENTS_SHIFT_CREATE_BUTTON = "Crear turno";
export const ABM_EVENTS_TABLE_DELETE = "Eliminar";
export const ABM_EVENTS_TABLE_DELETE_CONFIRM =
  "¿Está seguro que desea eliminar?";
